import {
    IDataArray
} from "./../../shared/index"

export class SurveySettings implements IDataArray {
    public Pkid = 0;
    public Title: string;
    public Description: string;
    public Message: string;
    public StartDate: Date;
    public ExpiresDate: Date;
    public Language: string;
    public AllowIgnore: boolean;
    public IsActive: boolean;
    public FileMetadataId: number;
    public CreatedBy: string;
    public CreatedOn: Date;
    public CreatedOnString: string;
    public ModifiedBy: string;
    public ModifiedOn: Date;
    public ModifiedOnString: string;
    public CreatedByUsername: string;
    public ModifiedByUsername: string;
    public SurveyAssignment: number;
    public IsLive: boolean;
    public ActiveNotes: string;

    public GetById(): number {
        return this.Pkid;
    }
}